<template>
    <div class="jobDetail">
        <div class="top">
            <app-header :oneList= "oneListData"></app-header>
        </div>
        <div class="content">
            <p class="positions">您的位置： <router-link to="/index">科研人才网</router-link> > <span>{{contentTitle}}</span></p>
            <div style="background-color:#fff;margin-bottom:40px;box-shadow: 10px 10px 10px #ccc;overflow: hidden;">
                <img style="width:980px;height:300px;display:block" v-show="imgs !=''" :src="imgs" alt="机构背景">
                <h3 class="titles">{{contentTitle}}</h3>
                <p class="detailMsg">
                    <span>发布时间：</span><i>{{beginTime.slice(0,10)}}</i>
                <!-- <span>截止时间：</span><i>{{endTime}}</i> -->
                    <span>工作地点：</span><i>{{address}}</i>
                    <span v-if="source !=''">来源：</span><i>{{source}}</i></p>
                <div v-html="contentList" id="contentTable" style="padding:0 40px 40px;"></div>
            </div>
        </div>
        <!-- <div class="ad">
            <div class="adRight">
                <div class="advisory">
                    <div class="adBlock">
                        <p @click="delivery" class="delivery">一键投递</p>
                    </div>
                    <div class="adBlock" @mouseover="qqFlag = true" @mouseout="qqFlag = false">
                        <p><img src="~@/assets/imgs/Path6.png" alt=""></p>
                        <p>QQ咨询</p>
                        <div v-show="qqFlag">
                            <p>扫一扫二维码</p>
                            <img src="~@/assets/imgs/Rectangle 10.png" alt="">
                            <p>咨询科研人才网</p>
                        </div>
                    </div>
                    <div class="adBlock" @mouseover="telShowFlag = true" @mouseout="telShowFlag = false">
                        <p><img src="~@/assets/imgs/Path 7.png" alt=""></p>
                        <p>联系电话</p>
                        <div v-show="telShowFlag">
                            <p>扫一扫二维码</p>
                            <img src="~@/assets/imgs/Rectangle 10.png" alt="">
                            <p>联系科研人才网</p>
                        </div>
                    </div>
                    <div class="adBlock" @mouseover="WeChatFlag = true" @mouseout="WeChatFlag = false">
                        <p><img src="~@/assets/imgs/Group.png" alt=""></p>
                        <p>关注微信</p>
                        <div v-show="WeChatFlag">
                            <p>扫一扫二维码</p>
                            <img src="~@/assets/imgs/Rectangle 10.png" alt="">
                            <p>关注科研人才网</p>
                        </div>
                    </div>
                    <div class="adBlock" @click="scrollToTop" >
                        <p style="padding-top:14px;"><img src="~@/assets/imgs/Shape 3.png" alt=""></p>
                    </div>
                </div>
            </div>
        </div> -->
        <div class="ad">
            <div class="adRight">
                <!-- <div  class="add" v-if="addList && addListFlag3">
                    <router-link :to="{path:'/jobDetail',query:{jobDetailId:addList[7][0].recruitId}}">
                        <img :src="addList[7][0].img" alt="">
                    </router-link>
                    <p @click="addListFlag3 = false">关闭</p>
                </div> -->
                <div class="advisory">
                    <div v-if="advisoryFlag" class="adBlock" style="padding:0">
                        <p @click="delivery" class="delivery">一键投递</p>
                    </div>
                    <div class="adBlock" @mouseover="qqFlag = true" @mouseout="qqFlag = false">
                        <a  href="http://wpa.qq.com/msgrd?v=3&uin=421555737&site=qq&menu=yes" target="_blank" >
                            <p><i class="icon iconfont"  style="color:#1787fb">&#xe63d;</i></p>
                            <p style="color:#666">QQ咨询</p>
                        </a>
                    </div>
                    <div class="adBlock" @mouseover="telShowFlag = true" @mouseout="telShowFlag = false">
                        <p><i class="icon iconfont">&#xe601;</i></p>
                        <p>联系电话</p>
                        <div v-show="telShowFlag" style="padding-top:30px;color:#333;height:100px;top:-24px;">
                            <p style="line-height:30px;">021-50829828</p>
                            <p>联系科研人才网</p>
                        </div>
                    </div>
                    <div class="adBlock" @mouseover="WeChatFlag = true" @mouseout="WeChatFlag = false">
                        <p><i class="icon iconfont">&#xe671;</i></p>
                        <p>关注微信</p>
                        <div v-show="WeChatFlag">
                            <p>扫一扫二维码</p>
                            <img src="~@/assets/imgs/WechatIMG.jpeg" alt="科研人才网-事业单位硕士博士科研人才招聘">
                            <p>关注科研人才网</p>
                        </div>
                    </div>
                    <div class="adBlock" @click="scrollToTop" style="padding:0">
                        <p style="padding-top:14px;"><img src="~@/assets/imgs/Shape 3.png" alt="科研人才网-硕士博士科研专项人才引进"></p>
                    </div>
                </div>
            </div>
        </div>
        <app-al :fiveListData = "threeList"></app-al>
        <app-footer></app-footer>
    </div>
</template>
<script>
import AppFooter from '../../components/common/footer.vue'
import AppHeader from '../../components/common/header2.vue'
import AppAd from '../../components/common/addif.vue'
import AppAl from '../../components/common/addil.vue'
import {get, postWithJson, form} from '@/api/services'
export default {
    name: 'jobDetail',
    components: { AppFooter,AppHeader, AppAd, AppAl},
    data () {
        return {
            jobDetailId:"",
            contentTitle:'',
            contentList:"",
            categoryName:"",
            beginTime:'',//开始时间
            // endTime:"",//结束时间
            address:"",//工作地点
            source:"",//信息来源
            imgs:'',
            qqFlag:false,
            telShowFlag:false,
            WeChatFlag:false,
            city:"",
            recruitId:"",
            oneListData:{},
            threeList:"",
            addList:{},
            addListFlag3:true,
            advisoryFlag:false,
        }
    },
    created:function () {
        this.jobDetailId = this.$route.query.jobDetailId;
        this.getDetail();
	},
    methods:{
        getDetail(){
            let _self = this;
            if(_self.jobDetailId == "" || _self.jobDetailId == undefined){
                this.$router.push({path:'/index'});
                _self.$message({
                    message: "网络错误，请重试！",
                    type: 'error'
                }); 
                return false;
            }
            postWithJson("front/recruit/queryRecruit",{recruitId:_self.jobDetailId}).then(
                function(response) {
                    if(response.data.status && response.data.data != null){
                        let resData = response.data.data[0];
                        if(resData.contentHead == null || resData.contentHead == undefined){
                            _self.$router.push({path:'/index'});
                            _self.$message({
                                message: "招聘内容已下线或正在整理中！",
                                type: 'error'
                            }); 
                            return false;
                        }
                        document.title = resData.title;
                        _self.contentList = resData.contentHead;
                        _self.beginTime = resData.createTime;
                        // _self.endTime  = resData.endTime;
                        _self.address = resData.provinceName;
                        _self.source = resData.source;
                        _self.city = resData.city;
                        _self.recruitId = resData.recruitId;
                        _self.contentTitle = resData.title;
                        _self.categoryName = resData.categoryName;
                        _self.imgs = resData.headPhoto ||"";
                        let myreg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
                        if (myreg.test(resData.pushEmail)) {
                            _self.advisoryFlag = true;
                        } 
                    }else{
                        _self.$router.push({path:'/index'});
                        _self.$message({
                            message: "招聘内容已下线或正在整理中！",
                            type: 'error'
                        }); 
                    }
                },
                function(response) {
                    _self.$message({
                        message: response.data.message,
                        type: 'error'
                    }); 	            
                }
            )
            var reqData = {categoryCode:100} 
            postWithJson('front/advertises/getAdvertisesList',reqData).then(
                function(response) {
                    if(response.data.status){
                        if(response.data.data){
                            let resData = response.data.data;
                            _self.oneListData = resData[1];
                            _self.threeList = resData[5];
                            _self.addList = resData[5];
                        }
                        
                    }else{
                        _self.$message({
                            message: response.data.message,
                            type: 'error'
                        }); 
                    }
                },
                function(response) {
                   _self.$message({
                        message: response.data.msg,
                        type: 'error'
                    });           
                }
                
            );
        },
        delivery(){ //投递简历
            let _self = this;
            let _id = localStorage.getItem('_id');
            let userCoookie = this.getCookie("session_token");
			if(userCoookie == null || userCoookie == ""){
				this.$router.push({ path:'/login',query:{loginFlag:true}});
				return false;
			}
			if(_id == "" || _id == null || _id == undefined){
                _self.$message({
                    message: "请登陆！",
                    type: 'error'
                });
                // _self.$message.error("请登陆！");
				_self.$router.push({ path:'/login',query:{loginFlag:true}});
				return false;
			}else{
				var reqData = {tel:_id} 
				postWithJson('front/user/getUserInfo',reqData).then(
					function(response) {
						if(response.data.status){
							console.log(response)
                            let _userId = response.data.data.id;
                            localStorage.setItem('_userId', _userId);
                            if(_userId == undefined || _userId == ""){
                                _self.$router.push({ path:'/personalCenter'})
                                _self.$message({
                                    message: "请完善个人简历！",
                                    type: 'error'
                                });
                                // _self.$message.error("请完善个人简历！");
                                return false;
                            }
                            let pernalName = response.data.data.name;		//姓名
                            

                            var reqData1 = {userId:_userId,
                                            name:pernalName,
                                            recruitId:_self.recruitId,
                                            cityName:_self.city,
                                            title:_self.contentTitle,
                                        } 
                            postWithJson('front/recruit/deliveryRecruit',reqData1).then(
                                function(response) {
                                    if(response.data.status){
                                        _self.$message({
                                            message: "投递成功!",
                                            type: 'success'
                                        }); 
                                    }else{
                                        _self.$message({
                                            message: response.data.message,
                                            type: 'error'
                                        });
                                    }
                                },
                                function(response) {
                                    _self.$message({
                                        message: response.data.message,
                                        type: 'error'
                                    });          
                                }
                            )





						}else{
							_self.$message({
                                message: response.data.message,
                                type: 'error'
                            });
						}
					},
					function(response) {
						_self.$message({
							message: response.data.message,
							type: 'error'
						});          
					}
				)
			}

        },
        handleScroll() {
            let dom =document.documentElement;
            this.scrollTop = dom.scrollTop;
            if (this.scrollTop > 300) {
                this.toTopShow = true;
            }else {
                this.toTopShow = false;
            }
        },
        scrollToTop() {
            console.log("1")
            let timer = null;
            let _this = this;
            cancelAnimationFrame(timer);
            timer = requestAnimationFrame(function fn() {
                if (_this.scrollTop > 5000) {
                    _this.scrollTop -= 1000;
                    document.documentElement.scrollTop=_this.scrollTop;
                    timer = requestAnimationFrame(fn);
                } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
                    _this.scrollTop -= 500;
                    document.documentElement.scrollTop = _this.scrollTop;
                    timer = requestAnimationFrame(fn);
                } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
                    _this.scrollTop -= 100;
                    document.documentElement.scrollTop = _this.scrollTop;
                    timer = requestAnimationFrame(fn);
                } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
                _this.scrollTop -= 10;
                    document.documentElement.scrollTop = _this.scrollTop;
                    timer = requestAnimationFrame(fn);
                } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
                    _this.scrollTop -= 5;
                    document.documentElement.scrollTop = _this.scrollTop;
                timer = requestAnimationFrame(fn);
                } else {
                cancelAnimationFrame(timer);
                _this.toTopShow = false;
                }
            });
        }
    },
    mounted() {
        this.$nextTick(function () {
            window.addEventListener('scroll', this.handleScroll,true);
        });
    },
    destroyed() {
        window.addEventListener('scroll', this.handleScroll,true);
    },
    watch: {
        $route(){
            this.jobDetailId= this.$route.query.jobDetailId;
            this.getDetail();
        }
    },
}
</script>
<style lang="less">
    #contentTable table{
        width: 880px!important;
    }
    @media all and (max-width: 768px) {
    
    #contentTable table{
        width: 100%!important;
    }
    
    
}
</style>
<style scoped = "scoped"  lang = "less">

.jobDetail{
    background:rgba(244,244,244,1);
    .top{
        width: 100%;
        background:rgba(23,135,251,1);
        .navs{
            width:1200px;
            height:50px;
            line-height: 50px;
            background:rgba(23,135,251,1);
            padding: 0 40px;
            box-sizing: border-box;
            margin: 0 auto;
            a{
                font-family:PingFangSC-Semibold;
                font-weight:600;
                color:rgba(255,255,255,1);
                box-sizing: border-box;
                font-size: 16px;
                padding: 0 4px;
                height: 40px;
                line-height: 40px;
                margin-top: 6px;
                margin-left: 25px;
            }
            a:first-child{
                margin-left: 0;

                border-bottom: 4px solid #fff;
            }
        }
    }
    .content{
        width: 980px;
        margin: 0 auto;
        .titles{
            text-align: center;
            color: #333;
            font-size: 24px;
            /* margin-top: 40px; */
            border-top: 1px solid #ddd;
            padding: 40px 40px 0;
        }
        .positions{
            color: #333;
            font-size: 14px;
            margin: 16px 0;
            a{
                color: #333;
                font-size: 14px;
            }
        }
        .detailMsg{
            text-align: center;
            color: #666;
            font-size: 14px;
            margin:20px 0;
            i{
                font-style: normal;
                margin-right: 8px;
            }
            span{
                margin-right: 6px;
            }
        }
    }
}
.ad{
    .add{
        position: relative;
        p{
            position: absolute;
            bottom: 0;
            width: 100%;
            height: 30px;
            line-height: 30px;
            background-color: #999;
            color: #fff;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            display: none;
        }
    }
    .add:hover p{
        display: block;
    }
    .adRight{
        position: fixed;
        top: 50%;
        right: 0;
        width: 80px;
        height: 530px;
        margin-top: -265px;
        img{
            width: 80px;
            height: 288px;
        }
        a:last-child{
            img{
                height: 220px;
                margin-top: 20px;
            }
        }
        .advisory{
            width: 60px;
            /* margin-top: 20px; */
            position: absolute;
            bottom: -20px;
            .adBlock{
                cursor: pointer;
                position: relative;
                width: 60px;
                height: 60px;
                color: #666;
                font-size: 12px;
                background-color: white;
                text-align: center;
                box-sizing: border-box;
                border-bottom: 1px solid #ccc;
                padding-top: 10px;
                .delivery{
                    height: 60px;
                    line-height: 60px;
                    cursor: pointer;
                    color: #fff;
                    background-color: #1787fb;
                }
                img{
                    width: 20px;
                    height: 20px;
                    margin-top: 10px;
                }
                .iconfont{
                    font-size: 24px;
                }
                div{
                    position: absolute;
                    width: 180px;
                    height: 170px;
                    right: 60px;
                    top: -60px;
                    background-color: white;
                    img{
                        width: 120px;
                        height: 120px;
                    }
                }
            }
            .adBlock:hover{
                .iconfont{
                    color: #1787fb;
                }
            }
        }
    }
}
@media all and (max-width: 768px) {
    .jobDetail{
        .content{
            width: 100%;
            img{
                display: none!important;
            }
            p,a{
                word-wrap:break-word;
            }
        }
    }
    #contentTable table{
        width: 100%!important;
    }
    
}
</style>



// WEBPACK FOOTER //
// src/views/job/jobDetail.vue